"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaskedPhoneNumberInputSchema = exports.default = void 0;
var MaskedPhoneNumberInput_1 = require("./MaskedPhoneNumberInput");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(MaskedPhoneNumberInput_1).default; } });
Object.defineProperty(exports, "MaskedPhoneNumberInputSchema", { enumerable: true, get: function () { return MaskedPhoneNumberInput_1.MaskedPhoneNumberInputSchema; } });
//# sourceMappingURL=index.js.map